import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { trackEvent } from '../utils/analytics';
type TestimonialItemProps = {
  id: string;
  name: string;
  role: string;
  lead: string;
  paragraphs: string[];
};
export function TestimonialItem({
  id,
  name,
  role,
  lead,
  paragraphs
}: TestimonialItemProps) {
  const [open, setOpen] = useState(false);
  const quoteId = `testimonial-${id}-quote`;
  const shown = open ? paragraphs : [lead];
  return <figure className="py-8 border-t border-rule first:border-t-0 first:pt-0" data-id="element-96" data-mp="1yjyxp6jqi5hx">
      <blockquote id={quoteId} className="font-serif text-lg md:text-xl leading-relaxed text-ink space-y-4 max-w-3xl" data-id="element-97" data-mp="1uhcaxk1x7arl">
        {shown.map((paragraph, index) => <p key={index} data-id="element-98" data-mp="1kq7xiorw7xyv" data-mpi={index}>
            {index === 0 && '“'}
            {paragraph}
            {index === shown.length - 1 && '”'}
          </p>)}
      </blockquote>

      <div className="mt-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 max-w-3xl" data-id="element-99" data-mp="2df56u2e4mkfh">
        <figcaption className="text-sm text-ink-soft" data-id="element-100" data-mp="329w8bg13k8uk">
          <span className="font-medium text-ink" data-id="element-101" data-mp="377y14sobrmj8">{name}</span>
          <span className="text-ink-mute" data-id="element-102" data-mp="377fzfgiw8g3x"> · {role}</span>
        </figcaption>
        <button type="button" onClick={() => {
        if (!open) trackEvent('testimonial_expand', {
          testimonial: id
        });
        setOpen(value => !value);
      }} aria-expanded={open} aria-controls={quoteId} aria-label={`${open ? 'See less' : 'See more'} of ${name}’s testimonial`} className="self-start inline-flex items-center gap-1.5 text-sm font-medium text-forest hover:text-forest-soft transition-colors duration-200" data-id="element-103" data-mp="2tfhwjnfrzgg7">
          {open ? <MinusIcon size={15} aria-hidden="true" data-id="element-104" data-mp="2ejsg04tczviv" /> : <PlusIcon size={15} aria-hidden="true" data-id="element-105" data-mp="8qby2mp2qazf" />}
          {open ? 'See less' : 'See more'}
        </button>
      </div>
    </figure>;
}